angular.module('clientDashboardApp')
  .filter('hourFormat', function() {
    return function(hour) {
      switch (true) {
        case hour == 12:
          return "12:00 PM"
        case hour == 0:
          return "12:00 AM"
        case hour < 12:
          return `${hour}:00 AM`
        default:
          return `${hour - 12}:00 PM`
      }
    };
  })
